<template>
  <div class="app-container">

    <nav class="head">
      <h2>Postcards by {{userName(uid)}}</h2>
        <router-link to="/settings"
          tag="button"
          class="icon settings" 
          v-if="isLoggedIn">
          <svg class="bigger"><use xlink:href="@/assets/svg/symbols.svg#settings">
            <title>Settings</title>
          </use></svg>
        </router-link>
      <router-link to="/login" 
        class="icon logout" 
        v-if="!isLoggedIn" 
        tag="button" >
        <svg><use xlink:href="@/assets/svg/symbols.svg#logout">
          <title>Sign In</title>
        </use></svg>
      </router-link>
      <button class="icon logout" @click="signOut()" v-if="isLoggedIn">
        <svg><use xlink:href="@/assets/svg/symbols.svg#logout">
          <title>Sign Out</title>
        </use></svg>
      </button> 
      <router-link to="/add-postcard" 
                   tag="button" 
                   @click="recordScrollPosition()"
                   :title="isLoggedIn ? 'Add a postcard' : 'You need to be logged into an account to add a postcard.'"
                   :event="isLoggedIn ? 'click' : ''" 
                   :class="isLoggedIn ? 'enabled' : 'disabled'"
      >Add Postcard</router-link>
      <router-link to="/postcards" tag="button" @click="recordScrollPosition(true)">Postcards</router-link>
      <router-link to="/home" tag="button" @click="recordScrollPosition()">Home</router-link>
    </nav>

    <div ref="pcContent" class="content" @scroll="onContentScroll($event)">
      <ul class="postcards">
        <postcard
          v-for="postcard in postcards"
          :key="postcard._id"
          :postcard="postcard"
          :showTranscript="showTranscript"
          :showUser="false"
          @photoselect="photoSelect"
          @editpostcard="onEditPostcard"
        ></postcard>
      </ul>
      <div v-if="!isLoading && !!postcards &&postcards.length === 0" class="postcards-message">No postcards have been added yet.</div>
    </div>

    <photo-viewer
      :path="photoUrl(selectedPhoto, 'full')"
      v-if="showPhotoViewer"
      @close="showPhotoViewer = false"
    />

    <div class="loading-mask" v-if="isLoading"><span>{{loadingMessage}}</span></div>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PhotoViewer from '@/components/PhotoViewer'
  import Postcard from '@/components/Postcard'

  let vm;
  export default {

    components: {
      PhotoViewer, Postcard
    },

    computed: {
      postcards() {
        console.log(`UserPostcards.postcards get for user ${this.uid}`);
        return this.$store.state.postcards.activeUserPostcards
      },
      scrollPosition() {
        return this.$store.state.postcards.userPostcardScrollPosition;
      },
      ...mapGetters('users', ['isLoggedIn', 'userId', 'userName']),
      ...mapGetters('photos', ['photoUrl'])
    },

    data() {
      return {
        isLoading: true,
        loadingMessage: 'Loading Postcards...',
        uid:'',
        showPhotoViewer: false,
        showTranscript: true,
        loadingNext: false,
        selectedPhoto: null,
        lastScrollPosition: 0
      }
    },

    watch: {
      '$store.state.users.userAuthenticating': (val, oldVal) => {
        console.log(`UserPostcards.watch($store.state.users.userAuthenticating) val [${val}] oldVal [${oldVal}]`);
        if (!val) {
          vm.init();
        }
      }
    },

    mounted() {
      console.log(`UserPostcards.mounted()`);// make sure user isn't being authenticated
      if (!this.$store.state.users.userAuthenticating) {
        this.init();
      }
      vm = this;
    },

    beforeDestroy() {
        this.recordScrollPosition();
    },

    methods: {
      
      init() {
        this.uid = this.$route.params.user_id;
        console.log(`UserPostcards.init() user id [${this.uid}]`);
        if (this.$store.state.postcards.userPostcards[this.uid] == null) {
          // get user names
          this.$store.dispatch('users/loadUserNames')
            .then(() => {
              console.log(`UserPostcards.init() usernames loaded`);
            })
            .catch(this.handleError)
          this.$store.dispatch('postcards/getPostcardsByUser', this.uid)
            .then(() => {
              console.log(`UserPostcards.init() postcards loaded`);
              this.isLoading = false;
            })
            .catch(this.handleError)
        }
        else {
          // check scroll position
          console.log(`UserPostcards.init() user scrollPosition [${this.scrollPosition}]`);
          this.$store.dispatch('postcards/getPostcardsByUser', this.uid);
          if (this.scrollPosition > 0) {
            this.$refs.pcContent.scrollTop = this.scrollPosition;
          }
          this.isLoading = false;
        }
      },

      signOut() {
        console.log('UserPostcards.signOut()');
        this.isLoading = true;
        this.$store.dispatch('users/logoutUser')
          .then(() => {
            this.isLoading = false;
          })
          .catch(this.handleError)
      },

      photoSelect(photo) {
        console.log(`UserPostcards.photoSelect() show full-size`);
        console.dir(photo);
        this.selectedPhoto = photo;
        this.showPhotoViewer = true;
      },

      onEditPostcard(postcard) {
        console.log(`UserPostcards.onEditPostcard()`);
        console.dir(postcard);
        this.loadingMessage = 'Loading Postcard...';
        this.isLoading = true;
        this.$store.commit('postcards/setActivePostcard', postcard);
        this.$router.push('/edit-postcard/' + postcard._id);
      },

      onContentScroll(evnt) {
        this.lastScrollPosition = this.$refs.pcContent.scrollTop;
        if (!this.loadingNext && (evnt.target.scrollTop + evnt.target.clientHeight * 2) > evnt.target.scrollHeight) {
          console.log(`UserPostcards.onContentScroll() trigger call to load more postcards`);
          this.loadingNext = true;
          this.$store.dispatch('postcards/getNextPostcards')
            .then((postcards) => {
              if (postcards && postcards.length > 0) {
                window.setTimeout(() => this.loadingNext = false, 200);
              }
            })
            .catch(this.handleError);
        }
      },

      recordScrollPosition(clearPosition) {
        const p = clearPosition ? 0 : this.lastScrollPosition ? this.lastScrollPosition : this.$refs.pcContent.scrollTop;
        console.log(`UserPostcards.recordScrollPosition() scrollTop [${p}] for user [${this.uid}]`);
        this.$store.commit('postcards/setUserScrollPosition', {position: p, user_id: this.uid})
      },

      handleError(err) {
        console.warn('UserPostcards.handleError()');
        console.dir(err);
        this.isLoading = false;
      }

    }

  }

</script>

<style lang="scss" scoped>

  .postcards-message {
    margin: 90px;
  }
  
</style>